'use client'

import Button from 'lib/components/Button/Button'
import { TextInputStandalone } from 'lib/components/Form'
import Header from 'lib/components/Header/Header'
import Link from 'lib/components/Link/Link'
import Notification from 'lib/components/Notification/Notification'
import { emailPattern } from 'lib/utilities/string'
import { useState } from 'react'

interface OtpRequestProps {
  onCancel: () => void
  onSuccess: (email: string) => void
  requesting: boolean
  requestError: string | null
  requestOtp: (email: string) => Promise<boolean>
}

export default function OtpRequest({
  onCancel,
  onSuccess,
  requesting,
  requestError,
  requestOtp,
}: OtpRequestProps) {
  const [email, setEmail] = useState('')

  const isValidEmail = emailPattern.test(email)

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    const ok = await requestOtp(email)
    if (ok) onSuccess(email)
  }

  return (
    <form onSubmit={handleSubmit}>
      <Header as="h2" className="type-body-3 mb-4">
        One-Time Password Sign In
      </Header>
      <p className="type-body-8 mb-2">
        Enter your email address to receive a one-time password on your mobile
        device.
      </p>
      <p className="type-body-8 mb-4">
        You must have a verified mobile number associated with your account.
      </p>
      {requestError && (
        <Notification
          size="small"
          icon={{ icon: 'error' }}
          type="urgent"
          title={requestError}
          className="mb-4 !text-left"
        />
      )}
      <TextInputStandalone
        label="Email*"
        placeholder="Email address"
        name="otpEmail"
        disabled={requesting}
        onChange={(val) => setEmail(String(val ?? ''))}
      />
      <Button
        type="submit"
        className="!mt-4 w-full !type-body-11-bold md:!type-body-5"
        disabled={requesting || !isValidEmail}
      >
        {requesting ? 'Sending...' : 'Get Code'}
      </Button>
      <div className="mt-4 text-center">
        <Link
          href="#"
          onClick={(e) => {
            e.preventDefault()
            onCancel()
          }}
          className="md:!text-xs"
        >
          Back to login
        </Link>
      </div>
    </form>
  )
}
